import { useQuery } from "@tanstack/react-query"
import { api } from "../../../http"
import { useRoleConf } from "../../../useRoleConf"
import { apiRoleConf } from "./myAdherentSummary.roleConf"
import type { AdherentSummary } from "./myAdherentSummary.type"

export const useMyAdherentSummary = () => {
  const { endpoint, queryKey } = useRoleConf(apiRoleConf)
  const { data: summary, isLoading } = useQuery({
    queryKey,
    queryFn: () => api.get<AdherentSummary>(endpoint),
    enabled: !!endpoint,
  })
  return { summary, isLoading }
}
